var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isTeqGroup
    ? _c(
        "div",
        { staticClass: "margin-medium-top" },
        [
          _c("app-display", {
            attrs: { label: "Tipo cadastrante:", content: _vm.tipoCadastrante }
          }),
          _vm.isAssociacaoJuridicamenteConstituida ||
          _vm.isEntidadeRepresentativa
            ? _c(
                "div",
                { key: "associacaoEntidade", staticClass: "padding" },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c("app-display", {
                            class:
                              _vm.compararTeqGroup &&
                              _vm.compararTeqGroup.mudouPessoa.mudouRazaoSocial
                                ? "text"
                                : "",
                            attrs: {
                              label: "Razão social:",
                              content: _vm.cadastrantePessoaJuridica.razaoSocial
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c("app-display", {
                            class:
                              _vm.compararTeqGroup &&
                              _vm.compararTeqGroup.mudouPessoa.mudouCNPJ
                                ? "text"
                                : "",
                            attrs: {
                              label: "CNPJ:",
                              content: _vm.cadastrantePessoaJuridica.cnpj
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c("app-display", {
                            class:
                              _vm.compararTeqGroup &&
                              _vm.compararTeqGroup.mudouPessoa.mudouEmail
                                ? "text"
                                : "",
                            attrs: {
                              label: "E-mail:",
                              content: _vm.cadastrantePessoa.email || "-"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c("app-display", {
                            class:
                              _vm.compararTeqGroup &&
                              _vm.compararTeqGroup.mudouPessoa.mudouTelefones
                                ? "text"
                                : "",
                            attrs: {
                              label: "Telefone(s):",
                              content: _vm.cadastrantePessoa.telefones
                                ? _vm.cadastrantePessoa.telefones.toString()
                                : "-"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "app-divider",
                    { attrs: { label: "Endereço" } },
                    [
                      _c(
                        "app-endereco",
                        {
                          staticClass: "paddingEndereco",
                          attrs: {
                            slot: "body",
                            endereco: _vm.cadastrante.pessoa.endereco,
                            mudouEndereco:
                              _vm.compararTeqGroup.mudouPessoa.mudouEndereco
                          },
                          slot: "body"
                        },
                        [
                          _vm.isAssociacaoJuridicamenteConstituida
                            ? _c("div", { key: "associacao" })
                            : _vm._e()
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.cadastrante.representantes &&
          _vm.cadastrante.representantes.length > 0
            ? _c(
                "div",
                { key: "entidade" },
                [
                  _c("div", [
                    _c(
                      "h3",
                      {
                        class: _vm.compararTeqGroup.mudouRepresentanteLegal
                          ? "text"
                          : "titulo"
                      },
                      [_vm._v("Representantes")]
                    )
                  ]),
                  _vm._l(_vm.cadastrante.representantes, function(
                    representante
                  ) {
                    return _c(
                      "app-collapse",
                      {
                        key: representante.id,
                        class:
                          _vm.compararTeqGroup &&
                          _vm.compararTeqGroup.mudouRepresentanteLegal
                            .mudouPessoa.mudouNome
                            ? "text"
                            : "",
                        attrs: {
                          collapsed: "1",
                          title: representante.pessoa.pessoaFisica.nome
                        }
                      },
                      [
                        _c("app-display", {
                          class:
                            _vm.compararTeqGroup &&
                            _vm.compararTeqGroup.mudouPessoa.mudouCPF
                              ? "text"
                              : "",
                          attrs: {
                            label: "CPF:",
                            content: representante.pessoa.pessoaFisica.cpf
                          }
                        }),
                        _c("app-display", {
                          class:
                            _vm.compararTeqGroup &&
                            _vm.compararTeqGroup.mudouPessoa.mudouRG
                              ? "text"
                              : "",
                          attrs: {
                            label: "RG:",
                            content: representante.pessoa.pessoaFisica.rg
                          }
                        }),
                        _c("app-display", {
                          class:
                            _vm.compararTeqGroup &&
                            _vm.compararTeqGroup.mudouPessoa.mudouRG
                              ? "text"
                              : "",
                          attrs: {
                            label: "Cargo/Função:",
                            content: representante.cargoFuncao
                          }
                        })
                      ],
                      1
                    )
                  })
                ],
                2
              )
            : _vm._e(),
          _vm.isOficioPresidente
            ? _c("div", { key: "oficio" }, [
                _c("p", {
                  staticClass: "margin-top",
                  domProps: { innerHTML: _vm._s(_vm.cadastrante.despacho) }
                })
              ])
            : _vm._e(),
          _vm.cadastrante.membrosComunidade &&
          _vm.cadastrante.membrosComunidade.length > 0
            ? _c("div", { key: "membros" }, [
                _c(
                  "div",
                  [
                    _c(
                      "h3",
                      {
                        class: _vm.compararTeqGroup.mudouMembroComunidade
                          ? "text"
                          : "titulo"
                      },
                      [_vm._v("Cadastrantes")]
                    ),
                    _vm._l(_vm.cadastrante.membrosComunidade, function(
                      membroComunidade
                    ) {
                      return _c(
                        "app-collapse",
                        {
                          key: membroComunidade.id,
                          attrs: {
                            title: membroComunidade.pessoa.pessoaFisica.nome,
                            collapsed: "1"
                          }
                        },
                        [
                          _c("app-display", {
                            attrs: {
                              label: "CPF:",
                              content: membroComunidade.pessoa.pessoaFisica.cpf
                            }
                          }),
                          _c("app-display-multiple", {
                            attrs: {
                              label: "Telefone(s):",
                              content:
                                membroComunidade.pessoa.listaTelefones ||
                                membroComunidade.pessoa.telefones ||
                                "-"
                            }
                          }),
                          _c("app-display", {
                            attrs: {
                              label: "E-mail:",
                              content: membroComunidade.pessoa.email,
                              marginBottom: true
                            }
                          }),
                          _vm.showMembroEndereco
                            ? _c(
                                "app-collapse",
                                {
                                  attrs: {
                                    collapsed: "1",
                                    title: "Endereço",
                                    showBorder: true
                                  }
                                },
                                [
                                  _c("app-endereco", {
                                    staticClass: "padding",
                                    attrs: {
                                      endereco: membroComunidade.pessoa.endereco
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          membroComunidade.documentos &&
                          membroComunidade.documentos.length > 0
                            ? _c("listagem-documentos", {
                                class:
                                  _vm.compararTeqGroup &&
                                  _vm.compararTeqGroup.mudouMembroComunidade
                                    .mudouDocumentos
                                    ? "text"
                                    : "",
                                attrs: {
                                  documentos: membroComunidade.documentos,
                                  idCadastroOriginal: _vm.cadastroOriginal.id,
                                  protocoloCadastroOriginal:
                                    _vm.cadastroOriginal.protocolo,
                                  ownerDocumento: "MEMBROS_DA_COMUNIDADE",
                                  idMembroComunidade: membroComunidade._id,
                                  versaoCadastro: _vm.versaoCadastro
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    })
                  ],
                  2
                )
              ])
            : _vm._e(),
          _vm.cadastrante.tipo === ""
            ? _c(
                "div",
                [
                  _c("app-display", {
                    attrs: {
                      label: "Nome do Cadastrante:",
                      content: _vm.cadastrante.nomeCadastrante,
                      marginBottom: true
                    }
                  }),
                  _c("app-display", {
                    attrs: {
                      label: "CPF do Cadastrante:",
                      content: _vm.cadastrante.cpfCadastrante,
                      marginBottom: true
                    }
                  }),
                  _c("app-display", {
                    attrs: {
                      label: "É funcionário do ITERMA?  ",
                      content: _vm.cadastrante.funcionarioIterma
                        ? "Sim"
                        : "Não",
                      marginBottom: true
                    }
                  }),
                  _c("app-display", {
                    attrs: {
                      label: "Nome do Terceirizado:",
                      content: _vm.cadastrante.nomeTerceirizado
                        ? _vm.cadastrante.nomeTerceirizado
                        : "-",
                      marginBottom: true
                    }
                  }),
                  _c("app-display", {
                    attrs: {
                      label: "CPF do Terceirizado:",
                      content: _vm.cadastrante.cpfTerceirizado
                        ? _vm.cadastrante.cpfTerceirizado
                        : "-",
                      marginBottom: true
                    }
                  })
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6535f81a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6535f81a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/informacoesCadastro/TeqGroup.vue
// module id = null
// module chunks = 